module.exports = __webpack_public_path__ + "img/ke.74ebf4d5.svg";